<template>
  <div class="content">
    <div class="content-header">
      <div class="content-header__title">Добро пожаловать в личный кабинет «Центра морского права»</div>
      <div class="header__notification">
        <button class="btn_notification" style="display:none;"><i class="far fa-bell"></i></button>
      </div>
    </div>
    <div class="filter">
      <div class="filter-option">
        <RouterLink class="button big light" active-class="active" :to="{name: 'setup'}">Теория</RouterLink>
        <RouterLink class="button big light" active-class="active" :to="{name: 'master-class'}">Мастер-класс</RouterLink>
        <RouterLink class="button big light" active-class="active" :to="{name: 'setup-practice'}">Практика</RouterLink>
        <!-- <RouterLink class="button big light" active-class="active" :to="{name: 'practice-exam'}">Практический экзамен</RouterLink> -->
<!--        <RouterLink class="button big light" active-class="active" :to="{name: 'practice-iyt'}">Практика IYT</RouterLink>-->
        <RouterLink class="button big light" :to="{name: 'tickets'}">Библиотека судоводителя</RouterLink>
        <RouterLink class="button big light" :to="{name: 'practice-batches'}">Оплаченные пакетные занятия</RouterLink>
      </div>
    </div>
    <div class="select-city">
      <i class="fas fa-map-marker-alt"></i>
      <div class="select-city-item"
           v-for="city in cities" :key="city.id"
           @click="city_id = city.id"
           :class="{ 'active': city_id === city.id }"
      >
        {{ city.name }}
      </div>
    </div>
    <div class="content-main">
      <CourseItem v-for="course in courses" :key="course.id" :course="course" @next-page="$emit('next-page')"/>
    </div>
  </div>
</template>

<script>

import CourseItem from "@/components/setup/CourseItem";
import {onMounted, ref, watch} from "@vue/runtime-core";
import {getCities} from "@/data/requests";
import {useRoute, useRouter} from "vue-router";
import {computed} from "@vue/reactivity";

export default {
  components: {
    CourseItem
  },
  props: ["data"],

  setup(props) {
    const cities = ref([]);
    const city_id = ref(1);
    const route = useRoute();
    const router = useRouter();
    const isMasterClass = router.currentRoute.value.name === 'master-class'

    const allCourses = computed(() => {
      return Array.isArray(props.data) ? props.data : (props.data?.value ?? []);
    });

    const parseRuDateTime = (str) => {
      if (!str) return Number.POSITIVE_INFINITY;
      const [datePart, timePart = '00:00'] = str.split(' ');
      const [day, month, year] = datePart.split('.').map(Number);
      const [hours, minutes] = timePart.split(':').map(Number);

      return new Date(year, month - 1, day, hours, minutes).getTime();
    };

    const courses = computed(() => {
      return allCourses.value
          .filter(course => course.city?.id === city_id.value)
          .sort((a, b) => {
            if (isMasterClass) {
              return parseRuDateTime(a.near_datetime) - parseRuDateTime(b.near_datetime);
            }
            return 0;
          })
    });

    onMounted(async () => {
      cities.value = await getCities();
    });

    watch(
        [() => route.query.id, () => allCourses.value],
        ([id]) => {
          if (!id) return;

          const found = allCourses.value.find(c => String(c.id) === String(id));
          if (found?.city?.id) {
            city_id.value = found.city.id;
          }

          console.log("courses:", courses.value);
        },
        { immediate: true }
    );

    return {
      cities,
      city_id,
      courses,
    };
  },
}
</script>
